import { Component, Input } from '@angular/core';

import { ResearchCard } from '../../models/research.card.interface';
import { UilabBaseComponentsModule } from '@uilab/base-components-angular';

import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-research-card',
    imports: [UilabBaseComponentsModule, DatePipe],
    templateUrl: './research-card.component.html',
    styleUrl: './research-card.component.scss',
})
export class ResearchCardComponent {
    @Input() card!: ResearchCard;
}
